import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { IVideoEditIncomingData } from '../../models/action/video';
import * as Actions from '../constants/video';

const _logger = Log.create('Video Reducer');

const videoReducer = (state = GlobalState().video, action: Types.IAction) => {
    if (!state) {
        return state;
    }
    const newState: any = {};
    if (action.type === Actions.actions.SET_ADD_VIDEO_QUESTION_DATA_DEFAULT) {
        newState.videoData = {
            name: '',
            description: '',
            isCommon: 0,
            taskDeadline: '',
            dateCriteria: 0,
            termWeekIds: [],
            datePrerequisiteActivityId: '',
            activityCompletionType: 1,
            completionType: 1,
            allUnits: false,
            selectedActivityUnitsTagIds: [],
            prerequisiteActivityId: '',
            alwaysOnTop: false,
            videoType: 0,
            selectedActivityOwnersTagIds: [],
            fileInputKey: '',
            cardImgName: '',
            learningOutcomeId: null
        };
        newState.questionData = {
            activityId: '',
            questions: []
        };
    }
    if (action.type === Actions.actions.SET_VIDEO_DATA) {
        const videoPageAction = (action as unknown) as IVideoEditIncomingData;
        newState.videoData = {
            activityId: videoPageAction.activityId,
            abbreviation: videoPageAction.abbreviation,
            name: videoPageAction.name,
            description: videoPageAction.description,
            isCommon: videoPageAction.isCommon ? 1 : 0,
            beginDate: videoPageAction.beginDate,
            endDate: videoPageAction.endDate,
            dateCriteria: videoPageAction.dateCriteria,
            datePrerequisiteActivityHours: videoPageAction.datePrerequisiteActivityHours ?? 0,
            datePrerequisiteActivityId: videoPageAction.datePrerequisiteActivityId ? [videoPageAction.datePrerequisiteActivityId] : '',
            prerequisiteActivityId: videoPageAction.prerequisiteActivityId ?? '',
            completionType: videoPageAction.completionType,
            completionCriteria: videoPageAction.completionCriteria,
            allowDownload: videoPageAction.allowDownload,
            fileEmbed: videoPageAction?.fileEmbed ?? ' ',
            alwaysOnTop: videoPageAction.alwaysOnTop,
            videoType: videoPageAction.videoType,
            dateRange: '',
            fileInputKey: '',
            photoUploadKey: '',
            activityConditionalBeginDate: videoPageAction.beginDate,
            activityConditionalEndDate: videoPageAction.endDate,
            termWeekIds: videoPageAction.termWeekIds,
            selectedActivityOwnersTagIds: videoPageAction.selectedActivityOwnersTagIds,
            selectedActivityUnitsTagIds: videoPageAction.selectedActivityUnitsTagIds,
            selectedClass: videoPageAction.selectedClass,
            allUnits: videoPageAction.allUnits,
            courseId: videoPageAction.courseId,
            file: videoPageAction?.file && videoPageAction.file.length > 0 ? videoPageAction.file : null,
            deletedFilesId: [],
            cardImgName: videoPageAction?.cardImgName,
            taskDeadline: videoPageAction?.taskDeadLine,
            taskDeadlinetime: '',
            learningOutcomeId: videoPageAction?.learningOutcomeId,
        };
        if (videoPageAction.videoQuestions) {
            newState.questionData = {
                activityId: videoPageAction.activityId,
                questions: videoPageAction.videoQuestions
            };
        }
    }
    return Object.assign({}, state, newState);
};

export default videoReducer;
